import { ValidationError } from "sequelize"
import {
    CcResponse,
    CcResponseCreate,
    CcResponseSave,
} from "server/models"
import { ASC } from "const"
import { GET, POST, DELETE, sort, validate } from "client/store/utils"
import { LangType } from "client/store"
import {
    CcResponseList,
    CcResponseValidation,
} from "./types"

export const LoadCcResponses = (
    accountId: number,
    projectId: number,
    module: number,
) => (
    GET(`/ccResponse/accountId/${accountId}/projectId/${projectId}/module/${module}`)
    .then((responses: CcResponse[]) => {
        const responseList: CcResponseList = {}
        responses.forEach((response) => {
            responseList[response.id] = response
        })

        const responsesSorted = responses.sort((a, b) => sort(a, b, "order", ASC))
        const responseIds: number[] = []
        responsesSorted.forEach((response) => {
            responseIds.push(response.id)
        })

        return { responseList, responseIds }
    })
)

export const LoadCcResponseById = (
    responseId: number,
    accountId: number,
    projectId: number,
) => (
    GET(`/ccResponse/id/${responseId}/accountId/${accountId}/projectId/${projectId}`)
    .then((response: CcResponse) => response)
)

export const SaveCcResponse = (
    id: number,
    response: CcResponseCreate,
    lang: LangType,
) => {
    const data: CcResponseSave = {
        id,
        response,
    }
    return POST(
        "/ccResponse/save",
        JSON.stringify(data),
    ).then((res) => {
        const newResponse = res as CcResponse
        const error = res as ValidationError
        return {
            newResponseId: newResponse.id || null,
            newResponseOrder: newResponse.order || null,
            validation: <CcResponseValidation>validate(error, lang),
        }
    })
}

export const DragnDropCcResponse = (
    responseIds: readonly number[],
    responseList: CcResponseList,
) => {
    const data: CcResponse[] = []
    responseIds.forEach((id, index) => {
        data.push({
            ...responseList[id],
            order: index,
        })
    })

    return POST(
        "/ccResponse/updateMany",
        JSON.stringify(data),
    ).then((success: boolean) => success)
}

export const DeleteCcResponse = (responseId: number) => (
    DELETE(`/ccResponse/delete/${responseId}`)
    .then((removedRows: number) => removedRows)
)

export const CopyDefaultCcResponses = (
    accountId: number,
    projectId: number,
    defaultResponsesAssigned: boolean,
) => (
    GET(`/ccResponse/copyDefault/accountId/${accountId}/projectId/${projectId}/${defaultResponsesAssigned}`)
    .then((success: boolean) => success)
)
